import { apiUrl } from 'config';
import axios from '../_helpers/axios';

export const campaignsService = {
  getAll,
  getDynamics,
  getHolidays,
  getInvoices,
  getPast,
  getData,
  save,
};

function getData(id) {
  return axios.get(`${apiUrl}/api/campaigns/getData`, { params: { id: id } });
}

function getAll() {
  return axios.get(`${apiUrl}/api/campaigns`);
}

function getHolidays() {
  return axios.get(`${apiUrl}/api/campaigns/getHolidays`);
}

function getInvoices() {
  return axios.get(`${apiUrl}/api/services/getInvoices`);
}

function getDynamics() {
  return axios.get(`${apiUrl}/api/reporting/getDynamics`);
}

function getPast() {
  return axios.get(`${apiUrl}/api/campaigns/getpast`);
}

async function save(data) {
  return await axios.post(`${apiUrl}/api/campaigns/save`, data);
}
